import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  columnList: string[] = [];
  totalSize: any;
  columnName: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    this.columnList = data['columnList'];
    this.totalSize = data['count'];
  }
  ngOnInit(): void {
    if (this.columnList && this.columnList.length > 0) {
      this.columnName = this.columnList.join(", ");
    }
  }

  proceed() {    
    this.dialogRef.close("Y");
  }

  preview() {    
    this.dialogRef.close("P");
  }    

  close() {
    this.dialogRef.close("N");
  }

  onClose(): void {
    this.dialogRef.close("N");
  }
}
